import { mapperEventAgendaSection } from '../event-agenda-section/mapper-event-agenda-section'
import { mapperGlobalDataTheme } from '../../../../core/data-layer/global-data/mappers'

/**
 * BlockEventAgendaSectionItem
 * @param {Object} data, content data
 * @return {Object} normalized data
 */

export const mapperEventBlockAgenda = (data: any) => {
  if (!data) {
    return null
  }
  return {
    id: data.sys?.id || '',
    title: data.title || '',
    contentType: data.contentType,
    description: data.blockAgendaDescription || {},
    items: data.agendaSectionsCollection?.items?.map(mapperEventAgendaSection) || [],
    theme: mapperGlobalDataTheme(data.theme)?.theme || null
  }
}
